import PageNotFound from '@/views/Errors/PageNotFound.vue'
import { AuthGuard } from '@/router/guards/AuthGuard.js'

export default [
	{
		path: '/:pathMatch(.*)*',
		name: 'error.not-found',
		component: PageNotFound,
		meta: {
			authGuard: AuthGuard.NoEnforcement,
			title: '404 Not Found'
		}
	}
]
